module.exports = __webpack_public_path__ + "static/media/vegitables_11.e1cb73e6.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_11.csv
// module id = 593
// module chunks = 0